'use client';

import { useEffect, useState, useMemo } from 'react';

import Image from 'next/image';
import { getTeamImageUrl } from '@/helpers/local-images-helper';
import { isTeamSupported } from '@/helpers/supported-images';

const CustomTeamImageWithDefault = ({
    teamId,
    width,
    height,
    alt = 'Imagen',
    className = '',
    style = {},
    onClick,
    unoptimized = true, // 🚨 Se mantiene true para evitar edge requests costosos
    priority = false,
    objectFit = 'cover', // Controlar cómo se ajusta la imagen
    ...props
}) => {
    // ✅ useMemo para memorizar las URLs y evitar recalcularlas en cada render
    // Usar directamente el helper que ya maneja la lógica de local vs CDN
    const analiticaImage = useMemo(() => {
        return getTeamImageUrl(teamId, width * 1.5, height * 1.5) ||
            `${process.env.NEXT_PUBLIC_IMAGES}/equipos/${teamId}.png?width=${width * 1.5}&height=${height * 1.5}`;
    }, [teamId, width, height]);

    const fallbackImage = useMemo(
        () => `${process.env.NEXT_PUBLIC_DEFAULT_IMAGES}/teams/${teamId}.png`,
        [teamId]
    );
    const [imageSrc, setImageSrc] = useState(analiticaImage);

    // ✅ Solo re-ejecutar cuando cambia la URL de analiticaImage (que ya está memoizada)
    useEffect(() => {
        setImageSrc(analiticaImage);
    }, [analiticaImage]);

    const handleError = () => {
        console.warn(`⚠️ Error cargando la imagen: ${analiticaImage}`);
        setImageSrc(fallbackImage);
    };

    return (
        <Image
            src={imageSrc}
            width={width}
            height={height}
            alt={alt}
            className={className}
            style={{ ...style, objectFit }}
            onClick={onClick}
            unoptimized={unoptimized} // 🔒 Se mantiene true por tu caso específico
            priority={priority}
            onError={handleError}
            {...props}
        />
    );
};

export default CustomTeamImageWithDefault;
